<template>
  <div class="chance-type">
    <div class="chance-type-content">
      <div class="content-t">
        <div class="content-t-left">
          <div class="title">
            <span>{{typeName}}</span>
          </div>
          <template v-if="tyList && tyList.length">
            <div class="list" v-for="(item,index) in tyList" :key="index" @click="linkToChance(item)">
              <span :title="item.information">{{item.information}}</span>
              <span>{{item.inTime | moment('YYYY/MM/DD')}}</span>
            </div>
          </template>
          <div v-else style="line-height:300px;text-align:center;">No Data！</div>
          <div class="m-page" v-if="tyTotalCount > tyPageSize">
            <Page
              show-total
              show-elevator
              :page-size="tyPageSize"
              :current="tyPageIndex"
              :total="tyTotalCount"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            />
          </div>
        </div>
        <div class="content-t-right">
          <exRelease :newChanceList="newChanceList" @finish="init"></exRelease>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import exRelease from "../chance/ex-release";
import { mapActions, mapGetters, mapMutations } from "vuex";


export default {
  name: "chance",
  data() {
    return {
      tyList: [], //商机列表
      newChanceList:[], // 最新商机
      tyPageSize: 10,
      tyPageIndex: 1,
      tyTotalCount: 0
    };
  },
  components: {
    exRelease
  },
  computed: { 
    ...mapGetters({
      exhibitionId:'getExhibitionId'
    }),
    typeName() {
      return this.$route.query.name;
    },
    typeId() {
      return this.$route.query.id;
    }
  },
  created() {
    this.init();
    // this.getNewChanceList();
  },
  methods: {
    ...mapActions({
      getReleaseType: "exhibitor/getReleaseType",
      getReleaseByTypeId: "exhibitor/getReleaseByTypeId",
    }),
    async init() {
      let list = await this.getReleaseByTypeId({
        exhibitionId: this.exhibitionId,
        compId: this.typeId,
        pageSize: this.tyPageSize,
        pageIndex: this.tyPageIndex,
      });
      if (list && list.items.length) {
        const pages = [];
        let arr = list.items.slice(0,9);
        arr.forEach((e, i) => {
          const c = Math.floor(i / 3);
          if (!pages[c]) {
            pages[c] = [];
          }
          pages[c].push(e);
        });
        this.newChanceList = pages;
        this.tyList = list.items;
      } else {
        this.newChanceList = [];
        this.tyList = [];
      }
      this.tyPageSize = list.pageIndex;
      this.tyPageSize = list.pageSize;
      this.tyTotalCount = list.totalCount;
    },
    async getNewChanceList() {
      let body = {
        ExhibitionId:this.exhibitionId,
        pageSize: 18,
        pageIndex: 1,
      };
      let list = await this.$service.getExChanceAllList(this,body);
        const pages = [];
        list = list.slice(0,9);
        list.forEach((e, i) => {
          const c = Math.floor(i / 3);
          if (!pages[c]) {
            pages[c] = [];
          }
          pages[c].push(e);
        });
        this.newChanceList = pages;
    },
    linkToChance(item) {
      const url = location.origin + `/chance-detailEn?chanceId=${item.id}`;
      window.open(url, "_blank");
      // this.$router.push(`/chance-detail?chanceId=${item.id}`);
    },
    changePage(e) {
      this.tyPageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.tyPageSize = e;
      this.init();
    },
  },
};
</script>

<style scoped lang='scss'>
.chance-type{
  background: #f5f5f5;
}
.chance-type-content{
  margin-top: 20px;
  width: 1200px;
  margin: 0 auto 90px;
  .content-t{
    display: flex;
  }
  .content-t-left{
    margin-right: 20px;
    width: 804px;
    background: #fff;
    padding-bottom: 50px;
    .title {
      width: 100%;
      height: 50px;
      border-bottom: 2px solid #024c8b;
      span {
        width: 130px;
        display: inline-block;
        line-height: 50px;
        background-color: #024c8b;
        text-align: center;
        color: #fff;
        font-size: 16px;
      }
    }
    .list {
      padding-left: 10px;
      margin-top: 10px;
      display: flex;
      cursor: pointer;
      span {
        display: inline-block;
      }
      span:first-child {
        width: calc(100% - 90px);
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        margin-right: 10px;
      }
      span:last-child {
        color: #666;
      }
    }
    .m-page {
      padding-top: 50px;
      text-align: center;
      /deep/ .ivu-page-item-active {
        background-color: #024c8b;
        border-color: #024c8b;
      }
      /deep/ .ivu-page-prev:hover, .ivu-page-next:hover {
        border-color: #024c8b;
        a {
          color: #024c8b;
        }
      }
      /deep/ .ivu-page-next:hover, .ivu-page-prev:hover {
        border-color: #024c8b;
        a {
          color: #024c8b;
        }
      }
      /deep/ .ivu-page-options-elevator input:hover {
        border-color: #024c8b;
        a {
          color: #024c8b;
        }
      }
      /deep/ .ivu-page-disabled:hover {
        border-color: #024c8b;
        a {
          color: #024c8b;
        }
      }
      /deep/ .ivu-page-options-elevator input:focus {
        border-color: #024c8b;
        box-shadow: rgba(2, 76, 39, 0.2) !important;
      }
      /deep/ .ivu-page-item:hover {
        border-color: #024c8b;
        a {
          color: #024c8b;
        }
      }
    }
  }
}
</style>